import React from 'react';
import styled from 'styled-components';
import MinggoFeature from '../components/featured/MinggoFeature';

const Wrapper = styled.div`
  min-height: 70vh;
  padding-top: var(--headerHeight);
  background-color: var(--darkBG);
`;

export default function MinggoPage() {
  return (
    <Wrapper>
      <MinggoFeature />
    </Wrapper>
  );
}
